import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { notification } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Service } from '@/infra/services/bera';

export interface SetBeraStepKeyResultsParams {
	task_rpn: number;
	job_element?: string;
	stress_level_id: string | null;
	frequency_id: string | null;
	total_task_duration_id: string | null;
	custom_report_step_key_id: string;
	id: string;
	organization_id: string;
	company_id: string;
}

export type SetBeraStepKeyResultsResponse = {
	id: string;
	task_rpn: number;
	job_element: string;
	stress_level_id: string;
	frequency_id: string;
	total_task_duration_id: string;
	custom_report_step_key_id: string;
};

export const useSetBeraStepKeyResult = () => {
	return useMutation<SetBeraStepKeyResultsResponse, AxiosError<Response>, SetBeraStepKeyResultsParams>(
		(params: SetBeraStepKeyResultsParams) => Service.setKeyResult(params),
		{
			onError: (err: any) => {
				const typeError = err.response.data.details[0]?.split('" ') ?? err;
				notification.error({
					message: I18n.get('Ops... something happened!'),
					description: I18n.get(typeError[1])
				});
			}
		}
	);
};
